import { Component, inject, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "mobi-office-custom-popup",
    templateUrl: "./custom-popup.component.html",
    styleUrl: "./custom-popup.component.scss",
    standalone: false
})
export class CustomPopupComponent implements OnInit {
  readonly data = inject(MAT_DIALOG_DATA) as {
    confirmMsg: string;
    onYes(): void;
    onNo(): void;
  };

  constructor() {}

  ngOnInit(): void {
    this.conFirmMsg = this.data.confirmMsg;
    this.onYes = this.data.onYes;
    this.onNo = this.data.onNo;
  }

  conFirmMsg: string = "";

  onYes(): void {}

  onNo(): void {}
}
